const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}
const validatePassword = (password) => {
  return password?.length >= 6
}

const validateZipCode = (zipcode) => {
  const reg = /(^\d{5}$)|(^\d{5}-\d{4}$)/
  return reg.test(zipcode)
}

const validatePhone = (phone) => {
  const phoneNum = phone.replaceAll('-', '')
  const re = /^\d+$/
  return re.test(phoneNum) && phoneNum?.length === 10
}

const phoneFormatting = (ele, restore) => {
  let newNumber
  const number = ele.value.replace(/\D/g, '')
  // automatically add dashes
  if (restore !== true) {
    if (number.length > 2) {
      // matches: 123 || 123-4 || 123-45
      newNumber = number.substring(0, 3) + '-'
      if (number.length === 4 || number.length === 5) {
        // matches: 123-4 || 123-45
        newNumber += number.substring(3)
      } else if (number.length > 5) {
        // matches: 123-456 || 123-456-7 || 123-456-789
        newNumber += number.substring(3, 6) + '-'
      }
      if (number.length > 6) {
        // matches: 123-456-7 || 123-456-789 || 123-456-7890
        newNumber += number.substring(6)
      }
    } else {
      newNumber = number
    }
  } else if (restore === true) {
    // delete - not join with -
    if (number.length > 3) {
      // matches: 123-4 || 123-45
      newNumber = number.substring(0, 3) + '-'
      if (number.length === 4 || number.length === 5 || number.length === 6) {
        // matches: 123-4 || 123-45 || 123-456
        newNumber += number.substring(3)
      } else if (number.length > 6) {
        // matches:  123-456-7 || 123-456-789
        newNumber += number.substring(3, 6) + '-'
      }
      if (number.length > 6) {
        // matches: 123-456-7 || 123-456-789 || 123-456-7890
        newNumber += number.substring(6)
      }
    } else {
      newNumber = number
    }
  }
  ele.value = newNumber.length > 12 ? newNumber.substring(0, 12) : newNumber
  return ele.value
}
const phoneNumberCheck = (field, e) => {
  const keyCode = e.keyCode
  const keyString = String.fromCharCode(keyCode)
  let pressDelete = false
  const dashKey = 189
  const deleteKey = [8, 46]
  const directionKey = [33, 34, 35, 36, 37, 38, 39, 40]
  const selectionEnd = field.selectionEnd

  // delete key was pressed
  if (deleteKey.indexOf(keyCode) > -1) {
    pressDelete = true
  }

  // only force formatting is a number or delete key was pressed
  if (keyString.match(/^\d+$/) || pressDelete) {
    return phoneFormatting(field, pressDelete)
  } else if (directionKey.indexOf(keyCode) > -1) {
    // do nothing for direction keys, keep their default actions
    // do nothing
  } else if (dashKey === keyCode) {
    if (selectionEnd === field.value.length) {
      field.value = field.value.slice(0, -1)
    } else {
      field.value =
        field.value.substring(0, selectionEnd - 1) +
        field.value.substr(selectionEnd)
      field.selectionEnd = selectionEnd - 1
    }
    return field.value
  } else {
    // all other non numerical key presses, remove their value
    e.preventDefault()
    return phoneFormatting(field, 'revert')
  }
}

const sameDayCheck = (prevDay, currDay) =>
  prevDay.getMonth() === currDay.getMonth() &&
  prevDay.getDate() === currDay.getDate()

export {
  validateEmail,
  validatePassword,
  validateZipCode,
  validatePhone,
  phoneFormatting,
  phoneNumberCheck,
  sameDayCheck
}
